import { motion } from "framer-motion";
import { XCircle, CheckCircle } from "@phosphor-icons/react";

const rows = [
  { label: "Paperwork", traditional: "Long, physical, repeated", invoquity: "Fully digital, one-time" },
  { label: "Collateral", traditional: "Required, often steep", invoquity: "Not required" },
  { label: "Approval time", traditional: "Weeks", invoquity: "24–48 hours target" },
  { label: "Process", traditional: "Rigid & bank-driven", invoquity: "Flexible & business-friendly" },
  { label: "Experience", traditional: "Branch visits", invoquity: "Online, on your schedule" },
];

export default function WhyInvoquity() {
  return (
    <section id="why" data-testid="why-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <p className="text-xs font-bold uppercase tracking-[0.28em] text-emerald-700 mb-3">Why Invoquity</p>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-slate-900">
            Not a traditional loan. A better way.
          </h2>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6 }}
          className="mt-14 rounded-3xl border border-slate-200 bg-slate-50/60 overflow-hidden"
        >
          <div className="grid grid-cols-3 text-sm font-semibold border-b border-slate-200 bg-white">
            <div className="p-5 text-slate-500 uppercase tracking-widest text-xs">Comparison</div>
            <div className="p-5 text-slate-500 uppercase tracking-widest text-xs">Traditional Loans</div>
            <div className="p-5 text-emerald-800 uppercase tracking-widest text-xs bg-emerald-50">Invoquity</div>
          </div>
          {rows.map((r, i) => (
            <div key={r.label} className={`grid grid-cols-3 items-center border-b border-slate-200 last:border-b-0 ${i % 2 === 0 ? "bg-white" : "bg-slate-50/40"}`} data-testid={`why-row-${i}`}>
              <div className="p-5 font-display text-base font-medium text-slate-900">{r.label}</div>
              <div className="p-5 flex items-center gap-2 text-slate-500">
                <XCircle size={18} weight="fill" className="text-slate-400 shrink-0" />
                <span className="text-sm">{r.traditional}</span>
              </div>
              <div className="p-5 flex items-center gap-2 bg-emerald-50/70 text-emerald-900">
                <CheckCircle size={18} weight="fill" className="text-emerald-700 shrink-0" />
                <span className="text-sm font-medium">{r.invoquity}</span>
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
